import { createApp } from 'vue';
import { initSentry } from './sentry';
import E from 'services/emitter';

import '@ohmsd/v-ui/styles/vars.css';
import 'styles/vars.css';
import 'styles/main.css';
import 'styles/badge.css';
import * as UI from 'components/sync';
import * as filters from '@ohmsd/utils/formatters';
import ROUTES from 'routes';

import router from 'router';
import vueStatic from 'vue-static';
import Notifications from '@kyvg/vue3-notification';
// import store from 'store';
import { DEV, PROD } from 'const';
import Root from 'components/Root.vue';

if (window.$stats) {
  router.afterEach((to/*, from*/) => {
    const { matched, meta, ...route } = to;
    window.$stats.history.push(route);
  });
}

// first icon for !PROD env should be first, others will be deleted. sily but true
if (!PROD) {
  const favicos = [...document.querySelectorAll('link[rel=icon]')].slice(1);
  favicos.forEach(ico => document.head.removeChild(ico));
}

const app = createApp(Root);
if (!DEV || window.location.host.endsWith('smalldata.app'))
  initSentry(app, router);

app.use(router);
// app.use(store);
app.use(vueStatic);
app.use(Notifications);
app.mixin({ mounted () { this.$el.__vue__ = this } });

// Vue.config.devtools = DEV;
Object.assign(
  app.config.globalProperties,
  {
    $log: (...args) => {
      window.console.log(...args);
      return args[0];
    },
    $root: app,
    ROUTES,
    DEV,
    PROD,
    flt: filters,
  },
);

// include all from '@ohmsd/v-ui/components';
Object.entries(UI).forEach(([name, cmp]) => app.component(name, cmp));

// app.mount('#sd-mount');
app.mount('#sd-mount');

// if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__)
//   window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app.constructor;

if (!DEV && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const firstInstall = !navigator.serviceWorker.controller;
    navigator.serviceWorker.register('/sw.js').then(
      reg => {
        window.console.log('Service Worker registered: ', reg);
        // show notify if any code updates detected
        reg.addEventListener('updatefound', e => {
          if (!firstInstall)
            E.emit('sw:updatefound', e);
        });
      },
      err => window.console.error('Service Worker error: ', err),
    );
  });
}

require('components/syncIndex.js');
